/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EdrCloudInstanceSpec { 
    /**
     * Description of the cloud instance.
     */
    description?: string;
    /**
     * Internal description.
     */
    internal_description?: string;
    /**
     * API endpoint to connect to EDR cloud instance.
     */
    api_endpoint: string;
    /**
     * The EDR cloud instance region.
     */
    edr_region: string;
}

